import $ from 'jquery';
import SwiperCore, { Navigation } from 'swiper/core';
import Swiper from 'swiper';
import LazyImages from '../../../components/lazy-images';
export default class CircledBackgroundSlider {
    static $slider = $('.js__circled-background-slider');
    static options = {
        initialSlide: this.$slider.data('initial-slide') || 0,
        slidesPerView: 'auto',
        loop: false,
        centeredSlides: true,
        spaceBetween: 22,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };
    static init() {
        if (!this.$slider.length) {
            return;
        }
        SwiperCore.use([Navigation]);
        this.$slider.each((index, slider) => {
            new Swiper(slider, {
                ...this.options,
            });
        });
        LazyImages.update();
    }
}
